import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Mic, Search, ZoomOut } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useScreenSize } from '@/hooks/useScreenSize';
interface MobileFloatingActionButtonProps {
  onCardCreate: () => void;
  onSearch: () => void;
  onOverview: () => void;
  onVoiceInput?: () => void;
  className?: string;
}
export const MobileFloatingActionButton = ({
  onCardCreate,
  onSearch,
  onOverview,
  onVoiceInput,
  className
}: MobileFloatingActionButtonProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    isSmallPhone,
    isTablet
  } = useScreenSize();
  const handleMainAction = () => {
    if (isExpanded) {
      setIsExpanded(false);
    } else {
      onCardCreate();
    }
  };
  const handleSecondaryAction = (action: () => void) => {
    action();
    setIsExpanded(false);
  };

  // Responsive sizing
  const fabSize = isSmallPhone ? 'h-12 w-12' : isTablet ? 'h-16 w-16' : 'h-14 w-14';
  const fabIconSize = isSmallPhone ? 'h-5 w-5' : isTablet ? 'h-7 w-7' : 'h-6 w-6';
  const secondarySize = isSmallPhone ? 'h-10 w-10' : isTablet ? 'h-12 w-12' : 'h-12 w-12';
  const secondaryIconSize = isSmallPhone ? 'h-4 w-4' : 'h-5 w-5';
  const bottomOffset = isSmallPhone ? 'bottom-16' : isTablet ? 'bottom-24' : 'bottom-20';
  const rightOffset = isSmallPhone ? 'right-3' : isTablet ? 'right-6' : 'right-4';
  const secondaryOffset = isSmallPhone ? 'bottom-12' : isTablet ? 'bottom-20' : 'bottom-16';
  return <div className={cn(`fixed ${bottomOffset} ${rightOffset} z-50`, className)}>
      {/* Secondary Actions */}
      {isExpanded && <div className={`absolute ${secondaryOffset} right-0 space-y-3 animate-in slide-in-from-bottom-2 fade-in`}>
          <Button size="sm" variant="secondary" className={`${secondarySize} rounded-full shadow-lg min-h-touch-target`} onClick={() => handleSecondaryAction(onSearch)}>
            <Search className={secondaryIconSize} />
          </Button>
          <Button size="sm" variant="secondary" className={`${secondarySize} rounded-full shadow-lg min-h-touch-target`} onClick={() => handleSecondaryAction(onOverview)}>
            <ZoomOut className={secondaryIconSize} />
          </Button>
          {onVoiceInput && <Button size="sm" variant="secondary" className={`${secondarySize} rounded-full shadow-lg min-h-touch-target`} onClick={() => handleSecondaryAction(onVoiceInput)}>
              <Mic className={secondaryIconSize} />
            </Button>}
        </div>}

      {/* Main FAB */}
      

      {/* Overlay to close expanded state */}
      {isExpanded && <div className="fixed inset-0 -z-10" onClick={() => setIsExpanded(false)} />}
    </div>;
};